/* eslint-disable max-len */
import React from 'react';

const ItalicIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" {...props}>
    <g fill="none" fillRule="evenodd">
      <g fill="currentColor">
        <g>
          <path
            d="M15 5L15 4 8 4 8 5 10.9 5 9.082 15 6 15 6 16 13 16 13 15 10.1 15 11.918 5z"
            transform="translate(-116.000000, -81.000000) translate(110.000000, 77.000000)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ItalicIcon;
